import React, { useEffect } from 'react';
import { Box, Card, CardContent, Divider, Typography, Grid } from '@mui/material';
import { Tooltip } from '@mui/material';
import OverflowTooltip from '../../helpers/OverflowTooltip';
import { formatDate } from '../../helpers/handleDate';
import { maxWidth } from '@mui/system';

function Education({ employeeData }) {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column'
            }}
        >
            <Card
                sx={{
                    position: 'relative',
                    padding: 2,
                    height: "100%",
                    borderRadius: '26px',
                    width: '80%',
                }}
            >
                <CardContent>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6" gutterBottom style={{ color: '#481E82', fontSize:{xs:"24px", sm:"34px"} }}>
                            SSLC
                        </Typography>
                    </Box>

                    <Divider sx={{ my: 1 }} />

                    {/* Layout */}
                    <Grid container sx={{ marginTop: 4 }} columnSpacing={2}>
                        {/* Left Section */}
                        <Grid item xs={12} sm={4}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <Box sx={{ marginBottom: { xs: 1, sm: 3 } }}>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        Institution
                                    </Typography>
                                    <Typography variant="body2" sx={{
                                        color: '#000001DE',
                                        fontSize: '18px',
                                        maxWidth: { xs: "70%", sm: '60%', md: '80%', lg: '100%' }, // Ensure it respects container width
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}
                                    >
                                        <OverflowTooltip>{employeeData?.education?.sslc?.institution || 'NA'}</OverflowTooltip>
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        Year of Passed Out
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>
                                        <OverflowTooltip>
                                            {employeeData?.education?.sslc?.year_of_passing ? formatDate(employeeData?.education?.sslc?.year_of_passing) : 'NA'}
                                        </OverflowTooltip>
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        {/* Middle Section */}
                        <Grid item xs={12} sm={4}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <Box sx={{ marginBottom: { xs: 1, sm: 3 } }}>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        Percentage
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>
                                        <OverflowTooltip>{employeeData?.education?.sslc?.perc || 'NA'}</OverflowTooltip>
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        SSLC File
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>
                                        <OverflowTooltip>{employeeData?.education?.sslc?.file || 'NA'}</OverflowTooltip>
                                    </Typography>
                                </Box>

                            </Box>
                        </Grid>

                        {/* Right Section */}
                        <Grid item xs={12} sm={4}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-end',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <Box sx={{ marginBottom: { xs: 1, sm: 3 } }}>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        Board
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>
                                        <OverflowTooltip>{employeeData?.education?.sslc?.department || 'NA'}</OverflowTooltip>
                                    </Typography>
                                </Box>

                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>


            <Card
                sx={{
                    position: 'relative',
                    padding: 2,
                    height: "100%",
                    borderRadius: '26px',
                    width: '80%',
                    marginTop: '20px'
                }}
            >
                <CardContent>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6" gutterBottom style={{ color: '#481E82', fontSize:{xs:"24px", sm:"34px"} }}>
                          HSC
                        </Typography>
                    </Box>

                    <Divider sx={{ my: 1 }} />

                    <Grid container sx={{ marginTop: 4 }} columnSpacing={2}>
                        <Grid item xs={12} sm={4}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <Box sx={{ marginBottom: { xs: 1, sm: 3 } }}>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        Institution
                                    </Typography>
                                    <Typography variant="body2" sx={{
                                        color: '#000001DE',
                                        fontSize: '18px',
                                        maxWidth: { xs: "70%", sm: '60%', md: '80%', lg: '100%' }, // Ensure it respects container width
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}>
                                        <OverflowTooltip>{employeeData?.education?.hlc?.institution || 'NA'}</OverflowTooltip>
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        Year of Passed Out
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>
                                        <OverflowTooltip>
                                            {employeeData?.education?.hlc?.year_of_passing ? formatDate(employeeData?.education?.hlc?.year_of_passing) : 'NA'}
                                        </OverflowTooltip>
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <Box sx={{ marginBottom: { xs: 1, sm: 3 } }}>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        Percentage
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>
                                        <OverflowTooltip>{employeeData?.education?.hlc?.perc || 'NA'}</OverflowTooltip>
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        hsc File
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>
                                        <OverflowTooltip>{employeeData?.education?.hlc?.file || 'NA'}</OverflowTooltip>
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-end',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <Box sx={{ marginBottom: { xs: 1, sm: 3 } }}>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        Board
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>
                                        <OverflowTooltip>{employeeData?.education?.hlc?.department || 'NA'}</OverflowTooltip>
                                    </Typography>
                                </Box>

                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>


            <Card
                sx={{
                    position: 'relative',
                    padding: 2,
                    height: "100%",
                    borderRadius: '26px',
                    width: '80%',
                    marginTop: '20px'
                }}
            >
                <CardContent>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6" gutterBottom style={{ color: '#481E82', fontSize:{xs:"24px", sm:"34px"} }}>
                            Diploma
                        </Typography>
                    </Box>

                    <Divider sx={{ my: 1 }} />

                    <Grid container sx={{ marginTop: 4 }} columnSpacing={2}>
                        <Grid item xs={12} sm={4}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <Box sx={{ marginBottom: { xs: 1, sm: 3 } }}>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        Institution
                                    </Typography>
                                    <Typography variant="body2" sx={{
                                        color: '#000001DE',
                                        fontSize: '18px',
                                        maxWidth: { xs: "70%", sm: '60%', md: '80%', lg: '100%' }, // Ensure it respects container width
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}>
                                        <OverflowTooltip>{employeeData?.education?.diploma?.institution || 'NA'}</OverflowTooltip>
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        Year of Passed Out
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>
                                        <OverflowTooltip>
                                            {employeeData?.education?.diploma?.year_of_passing ? formatDate(employeeData?.education?.diploma?.year_of_passing) : 'NA'}
                                        </OverflowTooltip>
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <Box sx={{ marginBottom: { xs: 1, sm: 3 } }}>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        Percentage
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>
                                        <OverflowTooltip>{employeeData?.education?.diploma?.perc || 'NA'}</OverflowTooltip>
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        File
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>
                                        <OverflowTooltip>{employeeData?.education?.diploma?.file || 'NA'}</OverflowTooltip>
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-end',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <Box sx={{ marginBottom: { xs: 1, sm: 3 } }}>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        Department
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>
                                        <OverflowTooltip>{employeeData.education.diploma.departmen || 'NA'}</OverflowTooltip>
                                    </Typography>
                                </Box>

                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            <Card
                sx={{
                    position: 'relative',
                    padding: 2,
                    height: "100%",
                    borderRadius: '26px',
                    width: '80%',
                    marginTop: '20px'
                }}
            >
                <CardContent>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6" gutterBottom style={{ color: '#481E82', fontSize:{xs:"24px", sm:"34px"} }}>
                            Bachelor's Degree
                        </Typography>
                    </Box>

                    <Divider sx={{ my: 1 }} />

                    <Grid container sx={{ marginTop: 4 }} columnSpacing={2}>
                        <Grid item xs={12} sm={4}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <Box sx={{ marginBottom: { xs: 1, sm: 3 } }}>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        Institution
                                    </Typography>
                                    <Typography variant="body2" sx={{
                                        color: '#000001DE',
                                        fontSize: '18px',
                                        maxWidth: { xs: "70%", sm: '60%', md: '80%', lg: '100%' }, // Ensure it respects container width
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}>
                                        {employeeData?.education?.bachelor?.institution || 'NA'}
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        Year of Passed Out
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>
                                        <OverflowTooltip>
                                            {employeeData?.education?.bachelor?.year_of_passing ? formatDate(employeeData?.education?.bachelor?.year_of_passing) : 'NA'}
                                        </OverflowTooltip>
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <Box sx={{ marginBottom: { xs: 1, sm: 3 } }}>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        Percentage
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>
                                        <OverflowTooltip>{employeeData?.education?.bachelor?.perc || 'NA'}</OverflowTooltip>
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        File
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>
                                        <OverflowTooltip>{employeeData?.education?.bachelor?.file || 'NA'}</OverflowTooltip>
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-end',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <Box sx={{ marginBottom: { xs: 1, sm: 3 } }}>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        Department
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>
                                        {employeeData?.education?.bachelor?.department || 'NA'}
                                    </Typography>
                                </Box>

                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            <Card
                sx={{
                    position: 'relative',
                    padding: 2,
                    height: "100%",
                    borderRadius: '26px',
                    width: '80%',
                    marginTop: '20px'
                }}
            >
                <CardContent>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6" gutterBottom style={{ color: '#481E82', fontSize:{xs:"24px", sm:"34px"} }}>
                            Master's Degree
                        </Typography>
                    </Box>

                    <Divider sx={{ my: 1 }} />

                    <Grid container sx={{ marginTop: 4 }}>
                        <Grid item xs={12} sm={4}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <Box sx={{ marginBottom: { xs: 1, sm: 3 } }}>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        Institution
                                    </Typography>
                                    <Typography variant="body2" sx={{
                                        color: '#000001DE',
                                        fontSize: '18px',
                                        maxWidth: { xs: "70%", sm: '60%', md: '80%', lg: '100%' }, // Ensure it respects container width
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}>
                                        {employeeData?.education?.master?.institution || 'NA'}
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        Year of Passed Out
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>
                                        <OverflowTooltip>
                                            {employeeData?.education?.master?.year_of_passing ? formatDate(employeeData?.education?.master?.year_of_passing) : 'NA'}
                                        </OverflowTooltip>
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <Box sx={{ marginBottom: { xs: 1, sm: 3 } }}>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        Percentage
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>
                                        <OverflowTooltip>{employeeData?.education?.master?.perc || 'NA'}</OverflowTooltip>
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        File
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>
                                        <OverflowTooltip>{employeeData?.education?.master?.file || 'NA'}</OverflowTooltip>
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-end',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <Box sx={{ marginBottom: { xs: 1, sm: 3 } }}>
                                    <Typography variant="body1" style={{ color: '#9E9E9E', fontSize: '14px' }}>
                                        Department
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#000001DE', fontSize: '18px' }}>
                                        <OverflowTooltip>{employeeData?.education?.master?.department || 'NA'}</OverflowTooltip>
                                    </Typography>
                                </Box>

                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Box>
    );
}

export default Education;